/** The value at a dot or bracket path (`a.b`, `a[0].b`); undefined once a step is missing. */
export const getPropertyByPath = <T>(object: T, path: string) => {
  if (!object || !path) return undefined;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let current: any = object;

  // Use regex to split the path into parts considering dot and bracket notation
  const parts = path
    .replace(/\[/g, ".") // Convert `[` to `.`
    .replace(/]/g, "") // Remove `]`
    .split(".");

  for (const part of parts) {
    if (current === null || current === undefined) {
      return undefined; // Respect optional chaining behavior
    }
    current = current[part];
  }

  return current;
};
